import React from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import s from "./EditDialog.module.scss";
import ButtonMAS from "ButtonMAS/ButtonMAS";

const EditDialog = ({
  open,
  dialogOncloseFn,
  title,
  content,
  confirmFn,
  isDialogEditing,
  editFn,
  negativeActionDisabled,
  negativeActionLoading,
  positiveActionDisabled,
  positiveActionLoading,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      slotProps={{ backdrop: { sx: { backgroundColor: "transparent" } } }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle
        id="scroll-dialog-title"
        sx={{ "&.MuiDialogTitle-root": { padding: "0 12px 0 24px" } }}
        className={s.dialogHeaderContainer}
      >
        <span className={s.dialogTitle}>{title}</span>
        <button 
          onClick={dialogOncloseFn} 
          disabled={negativeActionLoading || positiveActionLoading}
        >
          <CloseIcon />
        </button>
      </DialogTitle>
      <DialogContent
        sx={{ "&.MuiDialogContent-root": { padding: "24px 20px" } }}
      >
        <div className={s.dialogBody}>{content}</div>
      </DialogContent>
      <DialogActions>
        <div className={s.dialogAction}>
          {isDialogEditing ? (
            <>
              <ButtonMAS
                size="dialog-button"
                variant="secondary"
                onClick={editFn}
                disabled={negativeActionDisabled}
                isLoading={negativeActionLoading}
              >
                {t("component.edit.dialog.action.cancel")}
              </ButtonMAS>
              <ButtonMAS
                size="dialog-button"
                onClick={confirmFn}
                disabled={positiveActionDisabled}
                isLoading={positiveActionLoading}
              >
                {t("component.edit.dialog.action.save")}
              </ButtonMAS>
            </>
          ) : (
            <>
              <ButtonMAS
                size="dialog-button"
                variant="secondary"
                onClick={dialogOncloseFn}
              >
                {t("component.edit.dialog.action.cancel")}
              </ButtonMAS>
              <ButtonMAS size="dialog-button" onClick={editFn}>
                {t("component.edit.dialog.action.edit")}
              </ButtonMAS>
            </>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(EditDialog);
